<template>
  <div class="case-summary">
    <div class="case-name-container">
      <span class="case-name">Name: {{ name }}</span>
    </div>
    <div class="avatar-environments-container">
      <div class="case-avatar-container">
        <img class="circle thumbnail case-avatar md-image" :src="get(avatar, 'picture.url', defaultPatientPicture)">
      </div>
      <div
        v-for="env in environments"
        :key="env.id"
        class="case-environment-container"
      >
        <img :src="get(env, 'picture.url', defaultEnvironmentPicture)" class="rounded rectangle thumbnail case-environment md-image">
      </div>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get';
// import CardStack from '../../common/CardStack.vue';
import defaultPatientPicture from './default-patient.png';

export default {
  name: 'case-summary',
  components: {
    // CardStack,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    avatar: {
      type: Object,
      default: null,
    },
    environments: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      defaultPatientPicture,
      defaultEnvironmentPicture: 'http://icons.iconarchive.com/icons/papirus-team/papirus-status/128/image-missing-icon.png',
    };
  },
  methods: {
    get,
  },
};
</script>

<style scoped>
.case-summary {
  background-color: #262736;
  box-shadow: 2px 3px 5px 0px rgba(0, 0, 0, 0.75);
  padding: 15px 25px;
}

.case-name-container {
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.case-name {
  font-size: 15px;
  font-weight: 500;
}

/* .avatar-environments-container {
  display: flex;
  flex-direction: row;
} */

.case-avatar-container {
  padding: 10px 5px;
  padding-left: 0;
}

.case-avatar {
  background-color: white;
}

.case-environment-container {
  padding: 10px 5px;
}

.case-environment-container:last-child {
  padding-right: 0;
}

.avatar-environments-container {
  flex: 1;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
}

.case-environment {
  box-shadow: -4px 4px 5px 0px rgba(0,0,0,0.75);
}

.case-avatar {
  box-shadow: -4px 4px 5px 0px rgba(0,0,0,0.75);
}
</style>
